import React from 'react';
import ButtonLink from '../../../../elements/ButtonLink';

const VoteAgain = props => {
    const {question, settings, votingEnabled, i18n, onAnswerAgain} = props;

    if (!votingEnabled) return null;
    if (question.type != 'text') return null;
    if (!question.allow_multiple_text_answers) return null;

    return (
        <div className="content">
            <ButtonLink onClick={onAnswerAgain}>{i18n['button.vote.another-answer']}</ButtonLink>
        </div>
    );
};

export default VoteAgain;
